import {
  createProcureVendorContact,
  getProcureVendorById,
  getProcureVendorContactById,
  getProcureVendorContactsByProcureVendorId,
  PermissionsEnum,
  ProcureVendor,
  ProcureVendorContact,
} from 'vendor-marketplace-shared-library';
import { Grid, Typography } from '@mui/material';
import PrimaryButton from '../../../components/common/styled-mui-overrides/PrimaryButton';
import React, { useState } from 'react';
import useAuth from '../../../hooks/useAuth';
import ProcureVendorContactCard from './ProcureVendorContactCard';
import { useMutation } from '@apollo/client';
import { PROCURE_VENDOR_CONTACT_CREATE } from '../../../error-messages';
import useAlert from '../../../hooks/useAlert';
import Modal from '../../../components/common/Modal';
import ProcureVendorContactForm from '../../../components/vendors/ProcureVendorContactForm';
import { ProcureVendorContactInput } from '../../../types/vendors';

type ProcureVendorContactsModuleProps = {
  vendor: ProcureVendor;
};

export default function ProcureVendorContactsModule(props: ProcureVendorContactsModuleProps) {
  const { validateUserPermissions } = useAuth();
  const alert = useAlert();
  const [openCreateModal, setOpenCreateModal] = useState(false);

  const [createContact] = useMutation(createProcureVendorContact, {
    refetchQueries: [
      getProcureVendorById,
      getProcureVendorContactById,
      getProcureVendorContactsByProcureVendorId,
    ],
    awaitRefetchQueries: true,
    onError: error => {
      alert.setAlert({
        message: error?.message ?? PROCURE_VENDOR_CONTACT_CREATE,
      });
    },
    onCompleted: () => setOpenCreateModal(false),
  });

  const onCreate = async (formInput: ProcureVendorContactInput) => {
    await createContact({
      variables: {
        input: {
          procureVendorId: props.vendor.id,
          ...formInput,
        },
      },
    });
  };

  return (
    <Grid container rowGap={2} boxShadow={2} sx={styles.userContainer}>
      <Grid item container sx={styles.subContainer}>
        <Grid item>
          <Typography variant={'h6'}>Contact Persons</Typography>
        </Grid>
        {validateUserPermissions([PermissionsEnum.PROCURE_VENDOR_CONTACT_CREATE]) && (
          <Grid item>
            <PrimaryButton onClick={(e: React.MouseEvent<HTMLElement>) => setOpenCreateModal(true)}>
              Add
            </PrimaryButton>
          </Grid>
        )}
      </Grid>
      <Grid item container spacing={2}>
        {props.vendor.procureVendorContacts && props.vendor.procureVendorContacts?.length > 0 ? (
          props.vendor.procureVendorContacts.map((contact: ProcureVendorContact) => (
            <Grid item key={contact.id} xs={12}>
              <ProcureVendorContactCard contact={contact} />
            </Grid>
          ))
        ) : (
          <Grid item>
            <Typography>There are no contacts for this vendor yet.</Typography>
          </Grid>
        )}
      </Grid>
      <Modal title={'Add contact'} open={openCreateModal} setOpen={setOpenCreateModal}>
        <ProcureVendorContactForm onSubmit={onCreate} buttonText={'Add contact'} />
      </Modal>
    </Grid>
  );
}

const styles = {
  userContainer: {
    overflow: 'auto',
    padding: 2,
    borderRadius: 2,
    backgroundColor: 'secondary.light',
    flexDirection: 'column',
  },
  subContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  mainContainer: {
    backgroundColor: 'white',
    borderRadius: 2,
    padding: 2,
  },
};
